/**
 * @deprecated
 */
import $ from 'jquery';

const addStepNameToURl = () => {
	const formElements = document.getElementsByTagName('form');
	if (formElements[ 0 ]) {
		const stepName = formElements[ 0 ].getAttribute('data-step-name');
		if (stepName) {
			document.documentElement.classList.add(`step-${ stepName }`);
		}
	}
};

addStepNameToURl();

/**
 * Inicializuje pokročilé funkce pro komponentu s telefonním číslem.
 *
 * 1) Přidává CSS třídu podle délky prefixu (např. `pre-4` pro `+420`) na `select` s předvolbou.
 *    - Třída se automaticky aktualizuje při změně výběru.
 *    - Umožňuje stylovat `select` podle délky vybraného prefixu.
 *
 * 2) Zajišťuje správné spouštění živé validace navázané na skrytý `input`.
 *    - Propaguje události `change` a `blur` z viditelných prvků (předvolba, telefonní číslo) na skrytý `input`.
 *    - Při načtení stránky (nebo partial updatu) spustí validaci, pokud je telefonní číslo již předvyplněno.
 *
 * Funkce je volána při `DOMContentLoaded` a `partialUpdateComplete`.
 * Duplicitní inicializace na stejných prvcích je ošetřena pomocí `data-*` atributů.
 */
const initPhoneNumberFeatures = () => {
	const igSelects = document.querySelectorAll('.input-group-select select');
	igSelects.forEach(select => {
		if (select.hasAttribute('data-prefix-initialized')) return;
		select.setAttribute('data-prefix-initialized', 'true');
		const updatePrefixClass = () => {
			const selectedOption = select.options[select.selectedIndex];
			if (selectedOption && selectedOption.text) {
				const prefix = selectedOption.text.split(' ')[0];
				const prefixLength = prefix.length;
				select.classList.forEach(className => {
					if (className.startsWith('pre-')) {
						select.classList.remove(className);
					}
				});
				select.classList.add(`pre-${prefixLength}`);
			}
		};
		updatePrefixClass();
		select.addEventListener('change', updatePrefixClass);
	});
	const phoneFormGroups = document.querySelectorAll('.form-group--phone');
	phoneFormGroups.forEach(formGroup => {
		if (formGroup.hasAttribute('data-validation-initialized')) return;
		formGroup.setAttribute('data-validation-initialized', 'true');

		const hiddenInput = formGroup.querySelector('input.v-hidden');
		if (!hiddenInput) return;

		const baseId = hiddenInput.id;
		const visiblePhoneInput = document.getElementById(`${baseId}_phone`);
		const prefixSelect = document.getElementById(`${baseId}_prefix`);

		if (!visiblePhoneInput || !prefixSelect) return;

		// Trigger initial validation if the field is pre-filled
		if (visiblePhoneInput.value) {
			const blurEvent = new Event('blur', { bubbles: true });
			hiddenInput.dispatchEvent(blurEvent);
		}

		const triggerHiddenEvent = (e) => {
			const event = new Event(e.type, { bubbles: true });
			hiddenInput.dispatchEvent(event);
		};

		visiblePhoneInput.addEventListener('change', triggerHiddenEvent);
		visiblePhoneInput.addEventListener('blur', triggerHiddenEvent);
		prefixSelect.addEventListener('change', triggerHiddenEvent);
		prefixSelect.addEventListener('blur', triggerHiddenEvent);
	});
};
document.addEventListener('DOMContentLoaded', initPhoneNumberFeatures);
document.addEventListener('partialUpdateComplete', initPhoneNumberFeatures);


/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach((f) => {
		$(f);
	});
}



// WEBPACK FOOTER //
// ./fe/web-auto/src/js/web.js